export enum MartechFeatureFlags {
  CommunityForum = 'CommunityForumLinksInHeaderAndFooter',
  CowAddTokenAndSignatureToUrl = 'cow-add-token-and-signature-to-url',
  DEPanic = 'DE_Panic',
  FixedPrizeDrawNotificationEnabled = 'FixedPrizeDrawNotificationEnabled',
  FooterDateTime = 'footer_date_time',
  FreeBets = 'freebets',
  FreeSpins = 'eFreeSpinsBonuses',
  Ice2Feature = 'ice2',
  IceFeature = 'eIceFeatureEnabled',
  IceLeaderboard = 'eIceLeaderBoard',
  InstantBonusesVisibility = 'Visibility_MyStars_InstantBonuses',
  LoyaltyWidgetCasinoSports = 'pokerstars-rewards-casino-sports',
  LoyaltyWidgetRefresh = 'Loyalty_WidgetRefresh',
  MiniGameTickets = 'eMiniGameTickets',
  MktgMarketingCommunications = 'mktg-marketing-communications',
  MktgNoRewardsInScheduledTournaments = 'mktg-no-rewards-in-scheduled-tournaments',
  MktgTriggerPendingNotifications = 'mktg-trigger-pending-notifications',
  NoPokerStarsRewards = 'noPokerStarsRewards',
  PRHub = 'PromoExp_PromotionsAndRewards',
  PRHubDesktopPopupOpen = 'PRHUB_popup',
  PowerPathTile = 'mktg-power-path-tile',
  ReleaseBonuses = 'ReleaseBonuses',
  ShowJackpotWheel = 'Show-Jackpot-Wheel',
  SpinOfTheDayTile = 'mktg-spin-of-the-day-tile',
  SportsBonusCash = 'Visibility_MyStars_BonusCash',
  StarCode = 'mktg-star-code',
  TheDeal = 'the-deal',
  TheDealHighRoller = 'the-deal-highroller',
  TournamentMoney = 'Visibility_MyStars_TMoney',
  TournamentTickets = 'Visibility_MyStars_TournTickets',
  WebMPCNotificationEnabled = 'WebMPCNotificationEnabled',
  WebNotificationEnabled = 'WebNotificationEnabled',
  WebPokerEnabled = 'mktg-web-poker-enabled'
}
